const DirectUpload = {
  start() {
    console.log("DirectUpload.start()");

    document.addEventListener("direct-upload:initialize", DirectUpload.initialize);
    document.addEventListener("direct-upload:start", DirectUpload.begin);
    document.addEventListener("direct-upload:progress", DirectUpload.progress);
    document.addEventListener("direct-upload-error", DirectUpload.error);
    document.addEventListener("direct-upload:end", DirectUpload.end);
  },

  initialize(event) {
    const input = document.querySelector("form input[type='file']");

    if (input.multiple) {
      multipleFileUpload(event, input);
    } else {
      singleFileUpload(event);
    }

    function singleFileUpload(event) {
      // const id = event.detail.id;

      // const directUpload = document.createElement("div");
      // directUpload.classList.add("direct-upload");
      // directUpload.classList.add("direct-upload--single");
      // directUpload.classList.add("direct-upload--pending");
      // directUpload.id = "direct-upload-" + id;

      // const directUploadProgress = document.createElement("div");
      // directUploadProgress.classList.add("direct-upload__progress");
      // directUploadProgress.id = "direct-upload-progress-" + id;
      // directUpload.appendChild(directUploadProgress);

      // document
      //   .querySelector("body")
      //   .insertAdjacentElement("afterBegin", directUpload);

      const { target, detail } = event;
      const { id, file } = detail;

      let $wrappingDiv = $(target).parents(".file");
      let wrappingDiv = $wrappingDiv[0];

      // target.nextElementSibling.insertAdjacentHTML(
      wrappingDiv.insertAdjacentHTML(
        "beforeend",
        `<div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
          <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
          <span class="direct-upload__filename">${file.name}</span>
        </div>`
      );

      // target.nextElementSibling.querySelector(
      // $wrappingDiv[0].querySelector(
      //   `.direct-upload__filename`
      // ).textContent = file.name;
    }

    function multipleFileUpload(event, input) {
      const id = event.detail.id;

      const directUpload = document.createElement("div");
      directUpload.classList.add("direct-upload");
      directUpload.classList.add("direct-upload--multiple");
      directUpload.classList.add("direct-upload--pending");
      directUpload.id = "direct-upload-" + id;

      const directUploadProgress = document.createElement("div");
      directUploadProgress.classList.add("direct-upload__progress");
      directUploadProgress.id = "direct-upload-progress-" + id;
      directUpload.appendChild(directUploadProgress);

      const directUploadFilename = document.createElement("span");
      directUploadFilename.classList.add("direct-upload__filename");
      directUploadFilename.textContent = event.detail.file.name;
      directUpload.appendChild(directUploadFilename);

      input.insertAdjacentElement("beforeBegin", directUpload);
    }
  },

  begin(event) {
    console.log("direct-upload begin");

    const { id } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.remove("direct-upload--pending");
  },

  progress(event) {
    console.log("direct-upload progress");

    const { id, progress } = event.detail;
    const progressElement = document.getElementById(
      `direct-upload-progress-${id}`
    );
    progressElement.style.width = `${progress}%`;
  },

  error(event) {
    console.log("direct-upload error");

    event.preventDefault();

    const { id, error } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);

    element.classList.add("direct-upload--error");
    element.setAttribute("title", error);
  },

  end(event) {
    console.log("direct-upload end");
    const { id } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.add("direct-upload--complete");
  },

  update_label(event) {
    const input = event.target;
    const label = document.querySelector("label[for='" + input.id + "']");

    const text = input.files.length > 1 ? " fotos" : " foto";
    label.textContent = input.files.length + text;
  }
};

export default DirectUpload;
